export function metersToFeet(m: number): string {
  // 1 meter = 3.28084 feet
  const totalFeet = m * 3.28084;
  const feet = Math.floor(totalFeet);
  const inches = Math.round((totalFeet - feet) * 12);

  return `${feet}'${!!inches ? `${inches}"` : ""}`;
}
